import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import Footer from "../../components/footer/Footer";
import IconCard1 from "../../images/icon_card_5.png";
import IconCard2 from "../../images/icon_card_4.png";
import IconCard3 from "../../images/icon_card_3.png";
import IconCard4 from "../../images/icon_card_2.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS5 = () => {
  const solutions = [
    {
      title: "Struggling with Low Student Enrollment & Engagement?",
      problem:
        "Ineffective marketing, limited outreach, and low student retention.",
      solution:
        "Our SEO-optimized education portals, PPC campaigns, and personalized email marketing strategies help institutions attract more students and improve engagement.",
    },
    {
      title: "Need a Seamless Online Learning Experience?",
      problem:
        "Outdated platforms, poor User experience, Immature interaction and lack of mobile accessibility.",
      solution:
        "We develop responsive elearning platforms, intuitive LMS integrations, and AI-driven tutoring solutions for seamless digital learning experiences.",
    },
    {
      title: "Difficulty in Establishing Online Credibility & Presence?",
      problem:
        "Poor branding, lack of social proof, and low engagement on digital platforms.",
      solution:
        "Our social media branding, reputation management, and thought leadership content strategies help educational institutions build credibility and trust.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "Interactive & mobile-friendly educational websites",
        "Custom Learning Management Systems (LMS)",
        "Virtual classrooms & AI-powered tutoring solutions",
        "Course enrollment & student management platforms",
        "Secure online payment & e-learning integrations",
      ],
      image: require("../../images/web-development-3.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "SEO & content marketing to attract students",
        "PPC advertising to boost course enrollments",
        "Email campaigns & automation for student nurturing",
        "Social media marketing to build brand credibility",
        "Reputation & online presence management",
      ],
      image: require("../../images/digital-marketing-3.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    { title: "Modern e-learning UI/UX mockups", icon: IconCard1 },
    { title: "Virtual classroom & AI-driven learning demos", icon: IconCard2 },
    { title: "Engagement analytics & performance reports", icon: IconCard3 },
    {
      title: "Education marketing campaign success infographics",
      icon: IconCard4,
    },
  ];

  const caseStudyData = {
    sectionTitle: "Success Stories in Education",
    sectionSubtitle:
      "Our SEO-driven education platform increased student enrollments by 80% in just 6 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Transform Your Education Business",
    description:
      "Empower students, streamline operations, and enhance learning experiences with innovative digital solutions.",
    buttonText: "Lets Connect",
    image: require("../../images/education.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay updated on the latest trends in education technology and digital learning strategies.";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Empowering Education with Digital Innovation"}
          pageSub={
            "Transforming learning experiences with smart digital solutions that enhance accessibility, engagement, and student success."
          }
          backgroundImage={require("../../images/web-6.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Visualizing the Future of Education"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          boxAlign="center"
          titleColor="#fff"
          descriptionColor="#fff"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS5;
